// extracted by mini-css-extract-plugin
module.exports = {"timeSelect":"_3_5s2","skills":"_1tkXF","overdue":"_2rtrx","selectDescription":"_1norO"};